/**
 * Format currency values with BRL locale
 * @param {number} value - The value to format
 * @param {string} currency - The currency code (default: 'BRL')
 * @param {number} decimals - Fraction digits (default: 2; use more for per-unit rates)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, currency = 'BRL', decimals = 2) => {
  if (value === null || value === undefined || value === 0) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};

/**
 * Format number with decimal places
 * @param {number} value - The value to format
 * @param {number} decimalPlaces - Number of decimal places (default: 2)
 * @returns {string} Formatted number string
 */
export const formatNumber = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined) return '-';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(value);
};

/**
 * Format percentage values
 * @param {number} value - The value to format
 * @param {number} decimalPlaces - Number of decimal places (default: 2)
 * @returns {string} Formatted percentage string
 */
export const formatPercentage = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(value / 100);
};

/**
 * Format decimal values (0-1) to percentage strings
 * @param {number} value - The decimal value (0-1) to format as percentage
 * @param {number} decimalPlaces - Number of decimal places (default: 2)
 * @returns {string} Formatted percentage string
 */
export const formatDecimalToPercent = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(value);
};